/* CloudDream catalog recommendations for Essential Cart Drawer. */
(function (scope) {
  'use strict';

  var PORTAL_ID = 'essential-cart-drawer-portal';
  var TITLE_SELECTOR = '[data-essential-cart-element="upsell-title"]';
  var CAROUSEL_SELECTOR = '[data-essential-cart-element="upsell-products-carousel"]';
  var PRODUCT_SELECTOR = '[data-essential-cart-element="upsell-product"]';
  var CART_ITEM_SELECTOR = '[data-essential-cart-element="cart-drawer-item"]';
  var CART_TITLE_SELECTOR = '[data-essential-cart-element="line-item-title"]';
  var CART_VARIANT_SELECTOR = '[data-essential-cart-element="line-item-variant-selector"]';
  var CART_QUANTITY_SELECTOR = '[data-essential-cart-element="quantity-value"]';
  var CART_ITEM_LIST_WRAPPER_SELECTOR = '[data-essential-cart-element="cart-drawer-item-list-wrapper"]';
  var WRAPPER_SELECTOR = '[data-essential-cart-element="upsells-wrapper"]';
  var HIDDEN_CLASS = 'cd-cart-upsell-hidden';
  var EMPTY_CLASS = 'cd-cart-upsell-empty';
  var PRIMARY_CLASS = 'cd-cart-recommendation--primary';
  var LOWEST_CLASS = 'cd-cart-lowest';
  var PILLOWCASE_CLASS = 'cd-cart-pillowcases';
  var LOWEST_PRICE_DROP_ICON_URL = 'https://cdn.shopify.com/s/files/1/0553/0419/2034/files/2589-SNG-PriceDropAnimation2_2.gif';
  var CATALOG_CACHE_KEY = 'cd-cart-catalog-v2';
  var CATALOG_CACHE_TTL = 5 * 60 * 1000;
  var OWNED_MUTATION_SELECTOR = [
    '.cd-cart-recommendation',
    '.cd-cart-pillowcases',
    '.cd-cart-lowest',
    '.cd-cart-price-breakdown',
    '.cd-cart-grouped-price',
    '.cd-cart-grouped-quantity',
    '.cd-cart-summary__trust',
    '.cd-cart-upsell__copy',
    '.cd-cart-fixed-variant',
  ].join(',');
  var observedPortal = null;
  var portalObserver = null;
  var catalogPromise = null;
  var stringsCache = null;
  var renderPromises = new WeakMap();
  var renderTimers = new WeakMap();
  var rerenderPortals = new WeakSet();
  var cartSignatures = new WeakMap();
  var carouselNodes = new WeakMap();
  var pillowcaseNode = null;
  var lowestNode = null;

  var HANDLE_PRIORITY = [
    'cloudalign-pillow',
    'dreamers®-relief-pillow',
    'puff-pillow',
    'iceblanket',
    'cloudcool-cooling-comforter',
    'marshmellow-comforter',
    'bodyalign-cooling-pillow',
    'complete-pillow-set',
    'cooling-pillowcases',
    'dreamers-relief-pillowcase',
    'weighted-sleep-mask',
  ];

  var PRODUCT_GROUPS = {
    'cloudalign-pillow': 'pillow',
    'dreamers®-relief-pillow': 'pillow',
    'puff-pillow': 'pillow',
    iceblanket: 'bedding',
    'cloudcool-cooling-comforter': 'bedding',
    'marshmellow-comforter': 'bedding',
    'bodyalign-cooling-pillow': 'body',
    'complete-pillow-set': 'set',
    'cooling-pillowcases': 'accessory',
    'dreamers-relief-pillowcase': 'accessory',
    'weighted-sleep-mask': 'accessory',
  };

  var PILLOWCASE_MATCHES = {
    'cloudalign-pillow': 'cooling-pillowcases',
    'dreamers®-relief-pillow': 'dreamers-relief-pillowcase',
    'puff-pillow': 'cooling-pillowcases',
  };

  var COMPLEMENTARY_GROUPS = {
    pillow: ['bedding'],
    body: ['bedding'],
    bedding: ['pillow', 'body'],
    set: ['bedding'],
    accessory: ['pillow', 'bedding'],
  };

  var REGULAR_PILLOWCASE_KEY = 'cooling-pillowcases';

  function mergeCartUpsellStrings(globalStrings, configText) {
    var merged = Object.assign({}, globalStrings || {});
    if (!configText) return merged;
    return Object.assign(merged, JSON.parse(configText));
  }

  function getStrings() {
    if (stringsCache) return stringsCache;
    var globalStrings = scope.CloudDreamCartUpsellStrings || {};
    if (typeof document === 'undefined') return globalStrings;

    var config = document.getElementById('CloudDreamCartUpsellConfig');
    if (!config) return globalStrings;
    try {
      stringsCache = mergeCartUpsellStrings(globalStrings, config.textContent);
      return stringsCache;
    } catch (error) {
      console.error('[CloudDream] Cart recommendation copy is unavailable.', error);
      return globalStrings;
    }
  }

  function getVariantCommerce() {
    return getStrings().variantCommerce || {};
  }

  function createText(className, value) {
    var node = document.createElement('span');
    node.className = className;
    node.textContent = value;
    return node;
  }

  function getProductKey(href) {
    if (!href) return '';

    try {
      var url = new URL(href, 'https://clouddream.invalid');
      var match = url.pathname.match(/\/products\/([^/]+)/i);
      return match ? decodeURIComponent(match[1]).toLowerCase() : '';
    } catch (_error) {
      return '';
    }
  }

  function getBaseUrl() {
    return scope.location && scope.location.origin ? scope.location.origin : 'https://clouddream.invalid';
  }

  function getFeaturedImageUrl(imageUrl, baseUrl) {
    if (!imageUrl) return '';

    try {
      var url = new URL(imageUrl, baseUrl || getBaseUrl());
      url.searchParams.set('width', '230');
      return url.href;
    } catch (_error) {
      return '';
    }
  }

  function priceToCents(value) {
    if (typeof value === 'number') return Math.round(value * 100);
    var normalized = String(value || '').replace(/[^0-9.-]/g, '');
    return normalized ? Math.round(Number(normalized) * 100) : 0;
  }

  function formatMoney(cents) {
    var strings = getStrings();
    if (scope.CloudDreamMoney && typeof scope.CloudDreamMoney.money === 'function') {
      return scope.CloudDreamMoney.money(cents, strings.moneyFormat);
    }
    return String(cents / 100);
  }

  function imageUrl(image) {
    if (!image) return '';
    return getFeaturedImageUrl(typeof image === 'string' ? image : image.src || image.url || '');
  }

  function groupForKey(productKey) {
    return PRODUCT_GROUPS[productKey] || 'other';
  }

  function priorityForKey(productKey) {
    var index = HANDLE_PRIORITY.indexOf(productKey);
    return index === -1 ? HANDLE_PRIORITY.length : index;
  }

  function getVariantDiscountPercent(variant) {
    if (!variant || !(variant.compareAtPrice > variant.price)) return 0;
    return Math.round((variant.compareAtPrice - variant.price) / variant.compareAtPrice * 100);
  }

  function getBestDiscountedVariant(product) {
    var variants = (product.availableVariants && product.availableVariants.length)
      ? product.availableVariants
      : product.displayVariants;
    return (variants || []).reduce(function (best, variant) {
      var discount = getVariantDiscountPercent(variant);
      if (!discount) return best;
      return !best || discount > getVariantDiscountPercent(best) ? variant : best;
    }, null);
  }

  function getCartGroups(cartItems) {
    var groups = new Set();
    (cartItems || []).forEach(function (item) {
      var productKey = getCartProductKey(item);
      if (productKey) groups.add(groupForKey(productKey));
    });
    return groups;
  }

  function getComplementaryGroups(cartGroups) {
    var groups = new Set();
    (cartGroups || []).forEach(function (group) {
      (COMPLEMENTARY_GROUPS[group] || []).forEach(function (complementaryGroup) { groups.add(complementaryGroup); });
    });
    return groups;
  }

  function getOptionName(option) {
    return String(typeof option === 'string' ? option : option && option.name || '').trim();
  }

  function getOptionKey(optionName) {
    return String(optionName || '').trim().toLowerCase();
  }

  function normalizeCatalogProduct(product, variantCommerce) {
    var productKey = String(product.handle || '').toLowerCase();
    var optionNames = (product.options || [])
      .map(getOptionName)
      .filter(function (name) { return name && getOptionKey(name) !== 'title'; });
    var displayVariants = (product.variants || [])
      .map(function (variant) {
        var optionValues = {};
        optionNames.forEach(function (name, index) {
          optionValues[getOptionKey(name)] = (variant.options && variant.options[index])
            || variant['option' + (index + 1)]
            || '';
        });
        var commerce = variantCommerce && variantCommerce[String(variant.id)] || {};
        var inventoryQuantity = commerce.inventoryQuantity;
        var hasTrackedInventory = inventoryQuantity !== null
          && inventoryQuantity !== ''
          && Number.isFinite(Number(inventoryQuantity));
        var preOrder = hasTrackedInventory
          && Number(inventoryQuantity) <= 0
          && commerce.inventoryPolicy === 'continue'
          && Boolean(commerce.preOrderSellingPlanId);
        return {
          id: String(variant.id),
          title: variant.title || '',
          price: priceToCents(variant.price),
          compareAtPrice: priceToCents(variant.compare_at_price),
          image: imageUrl(variant.featured_image),
          optionValues: optionValues,
          available: Boolean(variant.available),
          preOrder: preOrder,
          sellingPlanId: preOrder ? String(commerce.preOrderSellingPlanId) : '',
          preOrderLabel: preOrder ? commerce.preOrderLabel || '' : '',
        };
      })
      .sort(function (a, b) { return a.price - b.price; });
    var availableVariants = displayVariants.filter(function (variant) { return variant.available; });

    if (!productKey || !displayVariants.length) return null;

    var featuredImage = imageUrl(product.featured_image || (product.images && product.images[0]));
    var selectedVariant = availableVariants[0] || displayVariants[0];
    return {
      productKey: productKey,
      group: groupForKey(productKey),
      priority: priorityForKey(productKey),
      title: product.title || product.handle,
      href: '/products/' + encodeURIComponent(product.handle),
      featuredImage: featuredImage,
      optionNames: optionNames,
      availableVariants: availableVariants,
      displayVariants: availableVariants.length ? availableVariants : displayVariants,
      selectedVariant: selectedVariant,
      minPrice: selectedVariant.price,
    };
  }

  function getCartProductKey(item) {
    return String(item && (item.handle || getProductKey(item.url || '')) || '').toLowerCase();
  }

  function getCartOptionValues(item) {
    var values = {};
    (item && item.options_with_values || []).forEach(function (option) {
      values[getOptionKey(option.name)] = option.value;
    });
    return values;
  }

  function getChangingOptions(product, cartItem, variants) {
    if (!product || !variants.length) return [];
    var selectedValues = getCartOptionValues(cartItem);
    if (!Object.keys(selectedValues).length) {
      var selectedVariantId = String(cartItem && (cartItem.variant_id || cartItem.id) || '');
      var selectedVariant = product.availableVariants.find(function (variant) {
        return String(variant.id) === selectedVariantId;
      });
      selectedValues = selectedVariant && selectedVariant.optionValues || {};
    }
    return (product.optionNames || []).filter(function (name) {
      var key = getOptionKey(name);
      var selectedValue = selectedValues[key];
      return !selectedValue || variants.some(function (variant) {
        return variant.optionValues && variant.optionValues[key] !== selectedValue;
      });
    });
  }

  function formatVariantHeading(optionNames, prefix) {
    if (!optionNames.length) return '';
    return String(prefix || 'Add another').trim() + ' '
      + optionNames.map(function (name) { return name.toLowerCase(); }).join(' & ');
  }

  function formatVariantLabel(product, variant) {
    if (!product || !variant) return '';
    var labels = (product.optionNames || []).map(function (optionName) {
      var value = variant.optionValues && variant.optionValues[getOptionKey(optionName)];
      return value ? optionName + ': ' + value : '';
    }).filter(Boolean);
    if (labels.length) return labels.join('\n');
    return variant.title && variant.title !== 'Default Title' ? variant.title : '';
  }

  function createVariantCard(product, variant) {
    return Object.assign({}, product, {
      title: product.title + ' — ' + variant.title,
      featuredImage: variant.image || product.featuredImage,
      availableVariants: [variant],
      displayVariants: [variant],
      selectedVariant: variant,
      minPrice: variant.price,
    });
  }

  function expandVariantCards(products, cartItems) {
    var cartVariantIds = new Set((cartItems || []).map(function (item) {
      return String(item && (item.variant_id || item.id) || '');
    }).filter(Boolean));
    return (products || []).flatMap(function (product) {
      var variants = product.displayVariants || product.availableVariants || [];
      return variants
        .filter(function (variant) { return !cartVariantIds.has(String(variant.id)); })
        .map(function (variant) { return createVariantCard(product, variant); });
    });
  }

  function partitionVariantRecommendations(products, cartItems, headingPrefix) {
    var items = cartItems || [];
    var cartProductKeys = new Set(items.map(getCartProductKey).filter(Boolean));
    var changingOptionKeys = new Set();
    var changingOptions = [];
    var primary = [];

    products.forEach(function (product) {
      if (!cartProductKeys.has(product.productKey)) return;
      var productCartItems = items.filter(function (item) {
        return getCartProductKey(item) === product.productKey;
      });
      var cartVariantIds = new Set(productCartItems.map(function (item) {
        return String(item.variant_id || item.id || '');
      }));
      var remainingVariants = product.availableVariants.filter(function (variant) {
        return !cartVariantIds.has(String(variant.id));
      });

      remainingVariants.forEach(function (variant) { primary.push(createVariantCard(product, variant)); });
      getChangingOptions(product, productCartItems[0], remainingVariants).forEach(function (optionName) {
        var optionKey = getOptionKey(optionName);
        if (changingOptionKeys.has(optionKey)) return;
        changingOptionKeys.add(optionKey);
        changingOptions.push(optionName);
      });
    });

    var complementaryGroups = getComplementaryGroups(getCartGroups(items));
    var secondary = products
      .filter(function (product) { return !cartProductKeys.has(product.productKey); })
      .map(function (product) {
        var discountedVariant = getBestDiscountedVariant(product);
        if (!discountedVariant) return null;
        return Object.assign({}, product, {
          selectedVariant: discountedVariant,
          minPrice: discountedVariant.price,
          discountPercent: getVariantDiscountPercent(discountedVariant),
          relevant: complementaryGroups.has(groupForKey(product.productKey)),
        });
      })
      .filter(Boolean)
      .sort(function (a, b) {
        if (a.relevant !== b.relevant) return a.relevant ? -1 : 1;
        return b.discountPercent - a.discountPercent
          || (a.priority == null ? priorityForKey(a.productKey) : a.priority)
            - (b.priority == null ? priorityForKey(b.productKey) : b.priority);
      });

    return {
      heading: formatVariantHeading(changingOptions, headingPrefix),
      primary: primary,
      secondary: secondary,
    };
  }

  function getPillowcaseRecommendations(products, cartItems) {
    var cartProductKeys = new Set((cartItems || []).map(getCartProductKey).filter(Boolean));
    var pillowKeys = Array.from(cartProductKeys).filter(function (productKey) {
      return Object.prototype.hasOwnProperty.call(PILLOWCASE_MATCHES, productKey);
    });

    if (!pillowKeys.length) return [];

    var requestedKeys = [];
    pillowKeys.forEach(function (pillowKey) {
      var matchingKey = PILLOWCASE_MATCHES[pillowKey];
      if (matchingKey && requestedKeys.indexOf(matchingKey) === -1) requestedKeys.push(matchingKey);
    });
    if (requestedKeys.indexOf(REGULAR_PILLOWCASE_KEY) === -1) requestedKeys.push(REGULAR_PILLOWCASE_KEY);

    return requestedKeys.map(function (productKey) {
      return products.find(function (product) { return product.productKey === productKey; });
    }).filter(Boolean);
  }

  function removePillowcaseRailProducts(products, pillowcaseProducts) {
    var pillowcaseKeys = new Set((pillowcaseProducts || []).map(function (product) {
      return product.productKey;
    }).filter(Boolean));
    return (products || []).filter(function (product) { return !pillowcaseKeys.has(product.productKey); });
  }

  function removePillowcaseRailVariants(products, pillowcaseCards) {
    var pillowcaseVariantIds = new Set((pillowcaseCards || []).map(function (card) {
      return String(card && card.selectedVariant && card.selectedVariant.id || '');
    }).filter(Boolean));
    return (products || []).filter(function (product) {
      var variantId = String(product && product.selectedVariant && product.selectedVariant.id || '');
      return !variantId || !pillowcaseVariantIds.has(variantId);
    });
  }

  function readCatalogCache(storage, now) {
    if (!storage || typeof storage.getItem !== 'function') return null;
    try {
      var cached = JSON.parse(storage.getItem(CATALOG_CACHE_KEY) || 'null');
      if (!cached || !Array.isArray(cached.products) || Number(cached.expiresAt) <= Number(now || Date.now())) {
        if (typeof storage.removeItem === 'function') storage.removeItem(CATALOG_CACHE_KEY);
        return null;
      }
      return cached.products;
    } catch (_error) {
      if (typeof storage.removeItem === 'function') storage.removeItem(CATALOG_CACHE_KEY);
      return null;
    }
  }

  function writeCatalogCache(storage, products, now) {
    if (!storage || typeof storage.setItem !== 'function' || !Array.isArray(products)) return false;
    try {
      storage.setItem(CATALOG_CACHE_KEY, JSON.stringify({
        expiresAt: Number(now || Date.now()) + CATALOG_CACHE_TTL,
        products: products,
      }));
      return true;
    } catch (_error) {
      return false;
    }
  }

  function shouldUseCatalogCache(variantCommerce) {
    return !variantCommerce || !Object.keys(variantCommerce).length;
  }

  function fetchCatalog() {
    if (catalogPromise) return catalogPromise;
    var variantCommerce = getVariantCommerce();
    var useCatalogCache = shouldUseCatalogCache(variantCommerce);
    var storage = null;
    try {
      storage = scope.sessionStorage;
    } catch (_error) {
      storage = null;
    }
    var cachedProducts = useCatalogCache ? readCatalogCache(storage, Date.now()) : null;
    if (cachedProducts) {
      catalogPromise = Promise.resolve(cachedProducts);
      scope.CloudDreamCatalogPromise = catalogPromise;
      return catalogPromise;
    }
    catalogPromise = scope.fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product catalog');
        return response.json();
      })
      .then(function (payload) {
        var products = (payload.products || []).map(function (product) {
          return normalizeCatalogProduct(product, variantCommerce);
        }).filter(Boolean);
        if (useCatalogCache) writeCatalogCache(storage, products, Date.now());
        return products;
      })
      .catch(function (error) {
        catalogPromise = null;
        console.error('[CloudDream] Cart recommendations unavailable.', error);
        return [];
      });
    scope.CloudDreamCatalogPromise = catalogPromise;
    return catalogPromise;
  }

  function productHref(product, variant) {
    return product.href + '?variant=' + encodeURIComponent(variant.id);
  }

  function getPdpPreOrderLabel(productKey, fallback, root, pathname) {
    var page = root || (typeof document !== 'undefined' ? document : null);
    var currentPath = pathname == null ? scope.location && scope.location.pathname || '' : pathname;
    if (getProductKey(currentPath) !== productKey) return String(fallback || '').trim();
    var button = page && page.querySelector && page.querySelector('.vcf-pre-order');
    return String(button && button.textContent || fallback || '').replace(/\s+/g, ' ').trim();
  }

  function getVariantPurchase(variant, strings) {
    var available = variant && variant.available !== false;
    var preOrder = available && Boolean(variant.preOrder && variant.sellingPlanId);
    var label = available
      ? preOrder ? variant.preOrderLabel || strings.preOrderLabel || 'Pre-order' : strings.addLabel || 'Add'
      : strings.soldOutLabel || 'Sold out';
    var fields = {
      id: variant && String(variant.id || ''),
      quantity: '1',
    };
    if (preOrder) fields.selling_plan = String(variant.sellingPlanId);
    return { disabled: !available, fields: fields, label: label, preOrder: preOrder };
  }

  function setCardVariant(card, product, variant) {
    var current = card.querySelector('.cd-cart-recommendation__current-price');
    var compare = card.querySelector('.cd-cart-recommendation__compare-price');
    var discount = card.querySelector('.cd-cart-recommendation__discount');
    var button = card.querySelector('.cd-cart-recommendation__button');
    var links = card.querySelectorAll('.cd-cart-recommendation__image-link, .cd-cart-recommendation__title');
    var image = card.querySelector('.cd-cart-recommendation__image');

    links.forEach(function (link) { link.href = productHref(product, variant); });
    if (current) current.textContent = formatMoney(variant.price);
    if (compare) {
      compare.textContent = variant.compareAtPrice > variant.price ? formatMoney(variant.compareAtPrice) : '';
      compare.hidden = variant.compareAtPrice <= variant.price;
    }
    if (discount) {
      if (variant.compareAtPrice > variant.price) {
        var percentage = Math.round((variant.compareAtPrice - variant.price) / variant.compareAtPrice * 100);
        discount.textContent = percentage + '% ' + getStrings().lowestDiscountSuffix;
        discount.hidden = false;
      } else {
        discount.textContent = '';
        discount.hidden = true;
      }
    }
    if (button) {
      var purchaseVariant = Object.assign({}, variant, {
        preOrderLabel: getPdpPreOrderLabel(product.productKey, variant.preOrderLabel),
      });
      var purchase = getVariantPurchase(purchaseVariant, getStrings());
      var buttonLabel = purchase.label;
      button.setAttribute('data-variant-id', variant.id);
      button.toggleAttribute('data-selling-plan-id', Boolean(purchase.fields.selling_plan));
      if (purchase.fields.selling_plan) button.setAttribute('data-selling-plan-id', purchase.fields.selling_plan);
      button.disabled = purchase.disabled;
      button.toggleAttribute('data-sold-out', purchase.disabled);
      button.toggleAttribute('data-pre-order', purchase.preOrder);
      button.textContent = buttonLabel;
      button.setAttribute('aria-label', buttonLabel + ' ' + product.title);
    }
    if (image && variant.image) image.src = variant.image;
  }

  function createRecommendationCard(product, railType) {
    var strings = getStrings();
    var card = document.createElement('article');
    var imageLink = document.createElement('a');
    var image = document.createElement('img');
    var title = document.createElement('a');
    var selector;
    var price = document.createElement('div');
    var current = createText('cd-cart-recommendation__current-price', '');
    var compare = document.createElement('s');
    var discount = document.createElement('span');
    var button = document.createElement('button');

    card.className = 'cd-cart-recommendation cd-cart-recommendation--' + railType;
    card.setAttribute('data-product-key', product.productKey);

    imageLink.className = 'cd-cart-recommendation__image-link';
    imageLink.tabIndex = -1;
    image.className = 'cd-cart-recommendation__image';
    image.src = product.featuredImage || product.selectedVariant.image;
    image.alt = product.title;
    image.loading = 'lazy';
    imageLink.appendChild(image);

    title.className = 'cd-cart-recommendation__title';
    title.textContent = product.title;

    var displayVariants = product.displayVariants || product.availableVariants;
    if (displayVariants.length > 1) {
      selector = document.createElement('select');
      selector.className = 'cd-cart-recommendation__variant';
      selector.setAttribute('aria-label', (strings.chooseOptionsLabel || 'Choose options') + ' ' + product.title);
      displayVariants.forEach(function (variant) {
        var option = document.createElement('option');
        option.value = variant.id;
        option.textContent = variant.title;
        selector.appendChild(option);
      });
      selector.addEventListener('change', function () {
        var variant = displayVariants.find(function (item) { return item.id === selector.value; });
        if (variant) setCardVariant(card, product, variant);
      });
    }

    price.className = 'cd-cart-recommendation__price';
    compare.className = 'cd-cart-recommendation__compare-price';
    price.append(current, compare);

    discount.className = 'cd-cart-recommendation__discount';

    button.className = 'cd-cart-recommendation__button';
    button.type = 'button';
    button.textContent = strings.addLabel || 'Add';
    button.setAttribute('aria-label', (strings.addLabel || 'Add') + ' ' + product.title);

    card.append(imageLink, title);
    if (selector) card.appendChild(selector);
    card.append(price);
    if (railType === 'lowest') card.appendChild(discount);
    card.appendChild(button);
    setCardVariant(card, product, product.selectedVariant);
    return card;
  }

  function submitVariant(variantId, button, sellingPlanId) {
    if (!variantId || !button || button.disabled) return false;
    var form = document.createElement('form');
    var submit = document.createElement('button');
    var purchase = getVariantPurchase({
      id: variantId,
      available: true,
      preOrder: Boolean(sellingPlanId),
      sellingPlanId: sellingPlanId,
    }, getStrings());

    form.action = '/cart/add';
    form.method = 'post';
    form.hidden = true;
    form.setAttribute('data-cd-recommendation-form', '');
    submit.type = 'submit';
    Object.keys(purchase.fields).forEach(function (name) {
      var input = document.createElement('input');
      input.name = name;
      input.value = purchase.fields[name];
      form.appendChild(input);
    });
    form.appendChild(submit);
    document.body.appendChild(form);
    button.disabled = true;
    form.requestSubmit(submit);
    scope.setTimeout(function () {
      form.remove();
      if (button.isConnected) button.disabled = false;
    }, 2500);
    return true;
  }

  function bindRail(rail) {
    if (!rail || rail.hasAttribute('data-cd-bound')) return;
    rail.setAttribute('data-cd-bound', '');
    rail.addEventListener('click', function (event) {
      var button = event.target.closest('.cd-cart-recommendation__button');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      submitVariant(
        button.getAttribute('data-variant-id'),
        button,
        button.getAttribute('data-selling-plan-id'),
      );
    });
  }

  function getSourceSlot(card, carousel) {
    var slot = card;
    while (slot && slot.parentElement && slot.parentElement !== carousel) slot = slot.parentElement;
    return slot || card;
  }

  function hideAppRecommendations(carousel) {
    if (!carousel) return;
    carousel.querySelectorAll(PRODUCT_SELECTOR).forEach(function (card) {
      var slot = getSourceSlot(card, carousel);
      slot.classList.add(HIDDEN_CLASS);
      slot.setAttribute('aria-hidden', 'true');
      slot.setAttribute('data-cd-upsell-hidden', '');
    });
  }

  function recommendationSignature(products) {
    return products.map(function (product) {
      return product.productKey + ':' + product.availableVariants.map(function (variant) { return variant.id; }).join(',');
    }).join('|');
  }

  function renderPrimary(portal, products, heading) {
    var wrapper = portal.querySelector(WRAPPER_SELECTOR);
    var carousel = portal.querySelector(CAROUSEL_SELECTOR);
    if (!wrapper || !carousel) return false;
    hideAppRecommendations(carousel);
    wrapper.classList.toggle(EMPTY_CLASS, !products.length);

    var signature = recommendationSignature(products);
    var existing = Array.from(carousel.querySelectorAll('.' + PRIMARY_CLASS));
    if (carousel.getAttribute('data-cd-primary-signature') === signature && existing.length === products.length) return true;
    existing.forEach(function (card) { card.remove(); });
    products.forEach(function (product) { carousel.appendChild(createRecommendationCard(product, 'primary')); });
    carousel.setAttribute('data-cd-primary-signature', signature);
    carousel.tabIndex = 0;
    carousel.setAttribute('aria-label', heading);
    bindRail(carousel);
    return true;
  }

  function renderLowestPrice(portal, products) {
    var strings = getStrings();
    var wrapper = portal.querySelector(WRAPPER_SELECTOR);
    var section = portal.querySelector('.' + LOWEST_CLASS);
    if (!wrapper || !products.length || !strings.lowestTitle || !strings.lowestSubtitle) {
      if (section) section.remove();
      lowestNode = null;
      return false;
    }

    if (!section) {
      section = document.createElement('section');
      section.className = LOWEST_CLASS;
      section.setAttribute('aria-labelledby', 'cd-cart-lowest-title');
    }
    if (!section.isConnected) wrapper.after(section);
    lowestNode = section;
    applyCartLayout(portal);

    var signature = recommendationSignature(products);
    if (section.getAttribute('data-cd-signature') === signature) return true;

    var heading = document.createElement('div');
    var text = document.createElement('div');
    var icon = document.createElement('img');
    var title = document.createElement('h2');
    var subtitle = document.createElement('p');
    var rail = document.createElement('div');
    heading.className = 'cd-cart-lowest__heading';
    text.className = 'cd-cart-lowest__text';
    icon.className = 'cd-cart-lowest__icon';
    icon.src = LOWEST_PRICE_DROP_ICON_URL;
    icon.alt = '';
    icon.loading = 'lazy';
    icon.setAttribute('aria-hidden', 'true');
    title.id = 'cd-cart-lowest-title';
    title.className = 'cd-cart-lowest__title';
    title.textContent = strings.lowestTitle;
    subtitle.className = 'cd-cart-lowest__subtitle';
    subtitle.textContent = strings.lowestSubtitle;
    text.append(title, subtitle);
    heading.append(text, icon);
    rail.className = 'cd-cart-lowest__rail';
    rail.tabIndex = 0;
    rail.setAttribute('aria-label', strings.lowestTitle);
    products.forEach(function (product) { rail.appendChild(createRecommendationCard(product, 'lowest')); });
    bindRail(rail);
    section.replaceChildren(heading, rail);
    section.setAttribute('data-cd-signature', signature);
    return true;
  }

  function renderPillowcases(portal, products) {
    var strings = getStrings();
    var anchor = portal.querySelector(CART_ITEM_LIST_WRAPPER_SELECTOR);
    var section = portal.querySelector('.' + PILLOWCASE_CLASS);
    if (!anchor || !products.length || !strings.extraPillowcaseTitle) {
      if (section) section.remove();
      pillowcaseNode = null;
      return false;
    }

    if (!section) {
      section = document.createElement('section');
      section.className = PILLOWCASE_CLASS;
      section.setAttribute('aria-labelledby', 'cd-cart-pillowcases-title');
    }
    if (!section.isConnected) anchor.after(section);
    pillowcaseNode = section;
    applyCartLayout(portal);

    var signature = recommendationSignature(products);
    if (section.getAttribute('data-cd-signature') === signature) return true;

    var title = document.createElement('h2');
    var rail = document.createElement('div');
    title.id = 'cd-cart-pillowcases-title';
    title.className = 'cd-cart-pillowcases__title';
    title.textContent = strings.extraPillowcaseTitle;
    rail.className = 'cd-cart-pillowcases__rail';
    rail.tabIndex = 0;
    rail.setAttribute('aria-label', strings.extraPillowcaseTitle);
    products.forEach(function (product) {
      rail.appendChild(createRecommendationCard(product, 'pillowcase'));
    });
    bindRail(rail);
    section.replaceChildren(title, rail);
    section.setAttribute('data-cd-signature', signature);
    return true;
  }

  function decorateTitle(portal, copy) {
    var title = portal.querySelector(TITLE_SELECTOR);
    if (!title || !copy) return false;
    if (title.textContent.trim() !== copy || !title.querySelector('.cd-cart-upsell__copy')) {
      title.replaceChildren(createText('cd-cart-upsell__copy', copy));
    }
    title.setAttribute('aria-label', copy);
    return true;
  }

  function applyCartLayout(portal) {
    var layout = scope.CloudDreamCartLayout;
    return Boolean(layout && layout.apply && layout.apply(portal));
  }

  // A rail the app tore out of its content column leaves the cart signature
  // untouched, so presence has to be tracked separately from content.
  function hasMissingOwnSection() {
    return Boolean(
      (pillowcaseNode && !pillowcaseNode.isConnected) || (lowestNode && !lowestNode.isConnected),
    );
  }

  function scheduleRender(portal, delay) {
    var existingTimer = renderTimers.get(portal);
    if (existingTimer) scope.clearTimeout(existingTimer);
    renderTimers.set(portal, scope.setTimeout(function () {
      renderTimers.delete(portal);
      renderRecommendations(portal);
    }, delay || 250));
  }

  function isInsideOwnedMutation(node) {
    var element = node && (node.nodeType === 1 ? node : node.parentElement);
    return Boolean(element && element.closest && element.closest(OWNED_MUTATION_SELECTOR));
  }

  function mutationRemovedPillowcaseRail(mutation) {
    return mutation.type === 'childList' && Array.from(mutation.removedNodes).some(function (node) {
      return node && node.nodeType === 1 && node.matches && node.matches('.' + PILLOWCASE_CLASS);
    });
  }

  function mutationNeedsRecommendationRefresh(mutation) {
    if (isInsideOwnedMutation(mutation.target)) return false;
    if (mutation.type !== 'childList') return true;
    if (mutationRemovedPillowcaseRail(mutation)) return true;
    var changedNodes = Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes));
    return changedNodes.some(function (node) { return !isInsideOwnedMutation(node); });
  }

  function canSkipRecommendationRefresh(mutations, signatureSame, carouselSame, fixedVariantMissing) {
    return signatureSame
      && carouselSame
      && !fixedVariantMissing
      && !mutations.some(mutationRemovedPillowcaseRail);
  }

  function getCartDomSignature(portal) {
    if (!portal || !portal.querySelectorAll) return '';
    return Array.from(portal.querySelectorAll(CART_ITEM_SELECTOR)).map(function (item) {
      var title = item.querySelector(CART_TITLE_SELECTOR);
      var variant = item.querySelector(CART_VARIANT_SELECTOR);
      var quantity = item.querySelector(CART_QUANTITY_SELECTOR);
      return [
        title && (title.getAttribute('href') || title.textContent.trim()),
        variant && (variant.value || variant.textContent.trim()),
        quantity && quantity.textContent.trim(),
      ].join(':');
    }).join('|');
  }

  function getDomCartItems(portal) {
    if (!portal || !portal.querySelectorAll) return [];
    return Array.from(portal.querySelectorAll(CART_ITEM_SELECTOR)).map(function (item) {
      var title = item.querySelector(CART_TITLE_SELECTOR);
      var variantControl = item.querySelector(CART_VARIANT_SELECTOR);
      var nestedSelect = variantControl && variantControl.querySelector && variantControl.querySelector('select');
      var quantity = item.querySelector(CART_QUANTITY_SELECTOR);
      var href = title && title.getAttribute('href') || '';
      var variantId = '';
      try {
        variantId = new URL(href, getBaseUrl()).searchParams.get('variant') || '';
      } catch (_error) {
        variantId = '';
      }
      variantId = variantId || variantControl && variantControl.value || nestedSelect && nestedSelect.value || '';
      return {
        handle: getProductKey(href),
        quantity: Math.max(1, Number.parseInt(quantity && quantity.textContent, 10) || 1),
        variant_id: String(variantId),
      };
    }).filter(function (item) { return item.handle && item.variant_id; });
  }

  function hasCartLines(portal) {
    return Boolean(portal && portal.querySelector && portal.querySelector(CART_ITEM_SELECTOR));
  }

  function setFixedVariantLabel(control, select, label, isFinalLabel) {
    if (!control || !select || !label) return false;
    var fixed = control.querySelector('.cd-cart-fixed-variant');
    if (!fixed) {
      fixed = document.createElement('span');
      fixed.className = 'cd-cart-fixed-variant';
      control.appendChild(fixed);
    }
    if (fixed.textContent !== label) fixed.textContent = label;
    if (isFinalLabel) fixed.setAttribute('data-cd-option-labelled', '');
    control.classList.add('cd-cart-fixed-variant-wrapper');
    select.classList.add('cd-cart-line-variant__select');
    if (select.parentElement) select.parentElement.classList.add('cd-cart-line-variant__control');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    return true;
  }

  function decorateImmediateCartVariantValues(portal) {
    if (!portal || !portal.querySelectorAll) return false;
    var decorated = false;
    Array.from(portal.querySelectorAll(CART_ITEM_SELECTOR)).forEach(function (item) {
      var control = item.querySelector(CART_VARIANT_SELECTOR);
      var select = control && control.querySelector && control.querySelector('select');
      var existing = control && control.querySelector('.cd-cart-fixed-variant[data-cd-option-labelled]');
      if (existing) return;
      var selectedOption = select && select.options && select.options[select.selectedIndex];
      var selectedText = selectedOption && selectedOption.textContent.trim();
      if (!selectedText) return;
      var fixedText = selectedText.split(/\s*\/\s*/).filter(Boolean).join('\n');
      if (setFixedVariantLabel(control, select, fixedText, false)) decorated = true;
    });
    return decorated;
  }

  function decorateCartVariantLabels(portal, products) {
    if (!portal || !portal.querySelectorAll) return false;
    var decorated = false;
    Array.from(portal.querySelectorAll(CART_ITEM_SELECTOR)).forEach(function (item) {
      var title = item.querySelector(CART_TITLE_SELECTOR);
      var control = item.querySelector(CART_VARIANT_SELECTOR);
      var select = control && control.querySelector && control.querySelector('select');
      var href = title && title.getAttribute('href') || '';
      if (!control || !select || !href) return;

      var product = products.find(function (candidate) { return candidate.productKey === getProductKey(href); });
      var variantId = '';
      try {
        variantId = new URL(href, getBaseUrl()).searchParams.get('variant') || '';
      } catch (_error) {
        variantId = '';
      }
      variantId = variantId || select.value || '';
      var variant = product && product.displayVariants.find(function (candidate) {
        return String(candidate.id) === String(variantId);
      });
      var label = formatVariantLabel(product, variant);
      if (!label) return;

      if (setFixedVariantLabel(control, select, label, true)) decorated = true;
    });
    return decorated;
  }

  function renderRecommendations(portal) {
    if (!portal) return Promise.resolve(false);
    if (!hasCartLines(portal)) return Promise.resolve(false);
    if (renderPromises.has(portal)) {
      rerenderPortals.add(portal);
      return renderPromises.get(portal);
    }
    decorateImmediateCartVariantValues(portal);
    var renderPromise = fetchCatalog()
      .then(function (products) {
        var cartItems = getDomCartItems(portal);
        var sellableProducts = products.filter(function (product) { return product.availableVariants.length; });
        var partition = partitionVariantRecommendations(sellableProducts, cartItems, getStrings().copy);
        // Only pillowcases with something in stock: a rail of nothing but
        // greyed "Sold out" cards is a dead end at the buy moment.
        var pillowcaseProducts = getPillowcaseRecommendations(sellableProducts, cartItems);
        var pillowcaseCards = expandVariantCards(pillowcaseProducts, cartItems);
        partition.primary = removePillowcaseRailVariants(partition.primary, pillowcaseCards);
        partition.secondary = removePillowcaseRailProducts(partition.secondary, pillowcaseProducts);
        decorateCartVariantLabels(portal, products);
        renderPillowcases(portal, pillowcaseCards);
        decorateTitle(portal, partition.heading);
        renderPrimary(portal, partition.primary, partition.heading);
        renderLowestPrice(portal, partition.secondary);
        return true;
      })
      .finally(function () {
        if (renderPromises.get(portal) === renderPromise) renderPromises.delete(portal);
        if (rerenderPortals.has(portal)) {
          rerenderPortals.delete(portal);
          scheduleRender(portal, 250);
        }
      });
    renderPromises.set(portal, renderPromise);
    return renderPromise;
  }

  function observePortal(portal) {
    if (!portal || portal === observedPortal) return;
    if (portalObserver) portalObserver.disconnect();
    observedPortal = portal;
    cartSignatures.set(portal, getCartDomSignature(portal));
    carouselNodes.set(portal, portal.querySelector(CAROUSEL_SELECTOR));
    decorateImmediateCartVariantValues(portal);
    renderRecommendations(portal);
    portalObserver = new MutationObserver(function (mutations) {
      applyCartLayout(portal);
      decorateImmediateCartVariantValues(portal);
      if (hasMissingOwnSection()) {
        scheduleRender(portal, 180);
        return;
      }
      if (!mutations.some(mutationNeedsRecommendationRefresh)) return;
      var signature = getCartDomSignature(portal);
      var carousel = portal.querySelector(CAROUSEL_SELECTOR);
      var fixedVariantMissing = portal.querySelector(CART_VARIANT_SELECTOR + ' select:not(.cd-cart-line-variant__select)');
      if (canSkipRecommendationRefresh(
        mutations,
        signature === cartSignatures.get(portal),
        carousel === carouselNodes.get(portal),
        fixedVariantMissing,
      )) return;
      cartSignatures.set(portal, signature);
      carouselNodes.set(portal, carousel);
      scheduleRender(portal, 180);
    });
    portalObserver.observe(portal, { childList: true, subtree: true });
  }

  function findPortal() {
    observePortal(document.getElementById(PORTAL_ID));
  }

  function init() {
    /* findPortal() -> observePortal() -> renderRecommendations() already
       fetches the catalog immediately whenever the cart has lines — that
       path is what actually needs it. There used to also be an unconditional
       idle-time fetchCatalog() call here, on every page load regardless of
       cart state; for an empty cart (no recommendations to render yet, since
       renderRecommendations bails out via hasCartLines) that fetch bought
       nothing and cost a full /products.json?limit=250 round trip on every
       first page view of a session. Removing it doesn't slow down the case
       that matters: the customer's first cart addition still triggers the
       portal's MutationObserver, which calls renderRecommendations and fetches
       the catalog fresh at exactly the moment it is first needed. */
    findPortal();
    if (observedPortal) return;
    var mountObserver = new MutationObserver(function () {
      findPortal();
      if (observedPortal) mountObserver.disconnect();
    });
    mountObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      canSkipRecommendationRefresh: canSkipRecommendationRefresh,
      expandVariantCards: expandVariantCards,
      getBestDiscountedVariant: getBestDiscountedVariant,
      getCartGroups: getCartGroups,
      getComplementaryGroups: getComplementaryGroups,
      getFeaturedImageUrl: getFeaturedImageUrl,
      getPdpPreOrderLabel: getPdpPreOrderLabel,
      getVariantPurchase: getVariantPurchase,
      getVariantDiscountPercent: getVariantDiscountPercent,
      formatVariantLabel: formatVariantLabel,
      getCartDomSignature: getCartDomSignature,
      getDomCartItems: getDomCartItems,
      hasCartLines: hasCartLines,
      mergeCartUpsellStrings: mergeCartUpsellStrings,
      getProductKey: getProductKey,
      getPillowcaseRecommendations: getPillowcaseRecommendations,
      mutationNeedsRecommendationRefresh: mutationNeedsRecommendationRefresh,
      normalizeCatalogProduct: normalizeCatalogProduct,
      partitionVariantRecommendations: partitionVariantRecommendations,
      readCatalogCache: readCatalogCache,
      removePillowcaseRailProducts: removePillowcaseRailProducts,
      removePillowcaseRailVariants: removePillowcaseRailVariants,
      shouldUseCatalogCache: shouldUseCatalogCache,
      writeCatalogCache: writeCatalogCache,
    };
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  }
})(typeof window !== 'undefined' ? window : globalThis);
